import React, { useEffect } from "react";
import { PreviewSelector } from "pages/MaterialSpecs/components/PreviewSelector";
import { useMaterialDetails, useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { useAnnotationsHandler } from "pages/MaterialSpecs/hooks/useAnnotationsHandler";
import { fetchAnnotations } from "store/features/annotations/annotations.actions";
import { useDispatch, useSelector } from "react-redux";
import { getMaterialDetailsById } from "store/features/materialSpecs/specs";
import { serverAddress } from "utils";

export const Preview = () => {
    const dispatch = useDispatch();
    const {
        preview,
        selectedMaterialSpecId,
        selectedMaterialId,
        type,
        setPreview,
        isPreviewVisible,
    } = useMaterialSpecs();
    const { reset } = useAnnotationsHandler();
    const materialDetails = useSelector(getMaterialDetailsById(selectedMaterialSpecId, selectedMaterialId));
    const { materialUrl, format } = useMaterialDetails(materialDetails);
    const { processedHeight: height, processedWidth: width } = useMaterialDetails(materialDetails);

    useEffect(() => {
        if (materialUrl && isPreviewVisible) {
            setPreview(`${serverAddress}${materialUrl}`, format, selectedMaterialSpecId, selectedMaterialId);
        }
    }, [isPreviewVisible, selectedMaterialSpecId, selectedMaterialId, preview, format, setPreview, materialUrl]);

    useEffect(() => {
        // todo: permissions for handling annotations are returned in two calls
        // from the server, which requires doubled annotation fetch request
        // talk with backend to improve permission handling
        if (selectedMaterialId && selectedMaterialSpecId && preview) {
            reset();
            dispatch(
                fetchAnnotations.request({
                    matSpecId: selectedMaterialSpecId,
                    adMaterialId: selectedMaterialId,
                })
            );
        }
    }, [selectedMaterialId, selectedMaterialSpecId, preview, dispatch, reset]);

    return <PreviewSelector preview={preview} type={type} width={width} height={height} />;
};
